import script from "./BodySubBiz.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubBiz.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubBiz.vue?vue&type=style&index=0&id=79a071af&module=biz&lang=css"
cssModules["biz"] = style0
import "./BodySubBiz.vue?vue&type=style&index=1&id=79a071af&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-79a071af"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn,QIcon});
